import React from 'react';
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
} from 'react-router-dom';

import ScrollToTop from 'shared/ScrollToTop';
import MainLandingPage from 'components/MainLanding/MainLandingPage';
import CorporateLandingPage from 'components/Corporate/Landing/CorporateLandingPage';
import DirectSourcing from 'components/Corporate/DirectSourcing/DirectSourcing';
import ComplianceClassification from 'components/Corporate/ComplianceClassification/ComplianceClassification';
import BackofficeLandingPage from 'components/Backoffice/Landing';
import MarketplaceLandingPage from 'components/Marketplace/Landing';
import AccountingFinancePayroll from 'components/Backoffice/AccountingFinancePayroll/AccountingFinancePayroll';
import EorEmployerOfRecordServices from 'components/Backoffice/EorEmployerOfRecordServices/EorEmployerOfRecordServices';
import BusinessComplianceServices from 'components/Backoffice/BusinessComplianceServices/BusinessComplianceServices';
import SecurityPage from 'components/SecurityPage';
import AboutUsPage from 'components/AboutUsPage';
import GoogleAnalytics from 'shared/GoogleAnalytics';
import HubspotTracking from 'shared/HubspotTracking';

export default function AppRouter() {
  return (
    <Router>
      <HubspotTracking />
      <GoogleAnalytics />

      <ScrollToTop />

      <Switch>
        <Route path="/" exact>
          <MainLandingPage />
        </Route>

        <Route path="/hr-staffing-solutions">
          <CorporateLandingPage />
        </Route>

        <Route path="/direct-sourcing">
          <DirectSourcing />
        </Route>

        <Route path="/contractor-compliance">
          <ComplianceClassification />
        </Route>

        <Route path="/financial-eor-compliance">
          <BackofficeLandingPage />
        </Route>

        <Route path="/accounting-financial-payroll">
          <AccountingFinancePayroll />
        </Route>

        <Route path="/eor-employer-of-record-services">
          <EorEmployerOfRecordServices />
        </Route>

        <Route path="/business-compliance-services">
          <BusinessComplianceServices />
        </Route>

        <Route path="/jobs-talent-aquisition">
          <MarketplaceLandingPage />
        </Route>

        <Route path="/information-security">
          <SecurityPage />
        </Route>

        <Route path="/about-us">
          <AboutUsPage />
        </Route>

        <Redirect from="*" to="/" />
      </Switch>
    </Router>
  );
}
